import {RootDesc} from "@ui/descriptions/RootDesc";
import {Logo} from "@ui/general/Logo";
import moment from "moment";
import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";
import {Link} from "react-router-dom";

import styles from "./styles.module.scss";

export const Footer = () => {
  const {language} = useSelector((state) => state.common.settings);
  const {t} = useTranslation();

  const footerLinkList = [
    {
      id: 0,
      name: t("footer.links.privacy"),
      link: "/privacy",
    },
    {
      id: 1,
      name: t("footer.links.terms"),
      link: "/terms",
    },
  ];

  return (
    <div className={styles.footerWrapper}>
      <div className={"container-big phone:p-0"}>
        <div className={styles.footer}>
          <div className={styles.footerInfo}>
            <Logo direction={"footer"} />

            <RootDesc>
              <span className={"text-[var(--white)]"}>
                © {moment().format("YYYY")}{" "}
              </span>

              <span
                className={"text-[var(--white)]"}
                dangerouslySetInnerHTML={{__html: t("footer.copyright")}}
              />
            </RootDesc>
          </div>

          <div className={styles.footerContent}>
            <h2
              dangerouslySetInnerHTML={{
                __html: t("footer.description"),
              }}
            />

            <div className={styles.contentBottom}>
              <ul>
                {footerLinkList.map((item) => (
                  <li key={item?.id}>
                    <RootDesc>
                      <Link to={item?.link}>{item?.name}</Link>
                    </RootDesc>
                  </li>
                ))}
              </ul>

              <RootDesc>
                <span className={"text-[var(--white)]"}>
                  {t("footer.contact")}{" "}
                  <a
                    target={"_blank"}
                    href={`mailto:info@vivanti.${
                      language === "en" ? "eu" : "ru"
                    }`}
                  >
                    {`info@vivanti.${language === "en" ? "eu" : "ru"}`}
                  </a>
                </span>
              </RootDesc>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
